"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  AlarmBellRing: ['alarm-bell-ring', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M4.5,7.5a1.014,1.014,0,0,0,.874-.507A5.343,5.343,0,0,1,7.457,4.9a1,1,0,1,0-.974-1.747A7.351,7.351,0,0,0,3.627,6.013a1,1,0,0,0,.384,1.362A.989.989,0,0,0,4.5,7.5Z', 'M6.432.712A1,1,0,0,0,5.186.044,7.5,7.5,0,0,0,.043,5.187a1,1,0,1,0,1.914.578,5.659,5.659,0,0,1,1.405-2.4,5.685,5.685,0,0,1,2.4-1.406A1,1,0,0,0,6.432.712Z', 'M19.146,4.386a7.425,7.425,0,0,0-1.629-1.229A1,1,0,1,0,16.543,4.9a5.361,5.361,0,0,1,2.084,2.087,1.018,1.018,0,0,0,1.362.384,1,1,0,0,0,.384-1.362A7.434,7.434,0,0,0,19.146,4.386Z', 'M23.957,5.187A7.5,7.5,0,0,0,18.814.044a1,1,0,1,0-.578,1.914,5.5,5.5,0,0,1,3.807,3.807,1.012,1.012,0,0,0,1.246.668A1,1,0,0,0,23.957,5.187Z', 'M13.5,21.5h-3a.5.5,0,0,0-.5.5,2,2,0,1,0,4,0A.5.5,0,0,0,13.5,21.5Z', 'M19,18.5a1,1,0,0,1-1-1V13c0-3.451-2.167-6.317-5-6.874V4.5a1,1,0,1,0-2,0V6.127C8.167,6.684,6,9.55,6,13v4.5a1,1,0,0,1-1,1,1,1,0,0,0,0,2H19a1,1,0,0,0,0-2Z']],
  AlarmBellCheck1: ['alarm-bell-check-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.5,21.5h-3A.5.5,0,0,0,6,22a2,2,0,0,0,4,0A.5.5,0,0,0,9.5,21.5Z', 'M11.838,7.646A5.662,5.662,0,0,0,9,6.127V4.5a1,1,0,1,0-2,0V6.127C4.168,6.684,2,9.55,2,13v4.5a1,1,0,0,1-1,1,1,1,0,0,0,0,2H15a1,1,0,1,0,0-2,1,1,0,0,1-1-1V13a7.912,7.912,0,0,0-.4-2.508A7,7,0,0,1,11.838,7.646Z', 'M18.5,0A5.5,5.5,0,1,0,24,5.5,5.5,5.5,0,0,0,18.5,0ZM17.376,8.118a.746.746,0,0,1-.53-.212l-1.5-1.5a.75.75,0,1,1,1.06-1.06l.97.969L20.6,3.1a.75.75,0,0,1,1.06,1.06l-3.75,3.75A.751.751,0,0,1,17.376,8.118Z']],
  AlarmBellCheck: ['alarm-bell-check', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.5,21.5h-3A.5.5,0,0,0,6,22a2,2,0,0,0,4,0A.5.5,0,0,0,9.5,21.5Z', 'M11.619,6.789A6.091,6.091,0,0,0,9.5,5.731V4.5a1.5,1.5,0,1,0-3,0v1.23c-2.921.791-5,3.777-5,7.27v.646a13.771,13.771,0,0,1-1.447,6.13A.5.5,0,0,0,.5,20.5h15a.5.5,0,0,0,.447-.724,13.785,13.785,0,0,1-1.447-6.13V13a8.541,8.541,0,0,0-.215-1.915A7.009,7.009,0,0,1,11.619,6.789Z', 'M18.5,0A5.5,5.5,0,1,0,24,5.5,5.5,5.5,0,0,0,18.5,0ZM17.375,8.126a.744.744,0,0,1-.53-.22l-1.5-1.5a.75.75,0,1,1,1.06-1.06l.97.969L20.6,3.1a.75.75,0,0,1,1.06,1.06l-3.75,3.75A.744.744,0,0,1,17.375,8.126Z']],
  AlarmBell1: ['alarm-bell-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M14.236,21H9.764a.25.25,0,0,0-.248.222A2.319,2.319,0,0,0,9.5,21.5a2.5,2.5,0,1,0,5,0,2.319,2.319,0,0,0-.016-.278A.248.248,0,0,0,14.236,21Z', 'M21.446,19.276A16.366,16.366,0,0,1,19.7,11.944v-.768a9.114,9.114,0,0,0-3.866-7.622A6.379,6.379,0,0,0,13.5,2.636V1.5a1.5,1.5,0,1,0-3,0V2.649A6.738,6.738,0,0,0,7.649,3.926,9.2,9.2,0,0,0,4.3,11.176v.768a16.366,16.366,0,0,1-1.746,7.332A.5.5,0,0,0,3,20H21a.5.5,0,0,0,.446-.725Z']],
  AlarmBell: ['alarm-bell', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21,17.5A1.5,1.5,0,0,1,19.5,16V11.138A7.957,7.957,0,0,0,13,3.073V1a1,1,0,0,0-2,0V3.073a7.957,7.957,0,0,0-6.5,8.065V16A1.5,1.5,0,0,1,3,17.5a1,1,0,0,0,0,2H21a1,1,0,0,0,0-2Z', 'M14.236,21H9.764a.25.25,0,0,0-.248.222A2.319,2.319,0,0,0,9.5,21.5a2.5,2.5,0,1,0,5,0,2.319,2.319,0,0,0-.016-.278A.248.248,0,0,0,14.236,21Z']],
  AlarmBellOff1: ['alarm-bell-off-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21,19.5a1,1,0,0,0,0-2A1.5,1.5,0,0,1,19.5,16V11.137a8.725,8.725,0,0,0-.4-2.617L8.121,19.5Z', 'M14.236,21H9.764a.251.251,0,0,0-.249.222A2.548,2.548,0,0,0,9.5,21.5a2.5,2.5,0,0,0,5,0,2.547,2.547,0,0,0-.016-.278A.249.249,0,0,0,14.236,21Z', 'M1,23.993a1,1,0,0,0,.707-.286l22-22a1.014,1.014,0,0,0,0-1.414,1,1,0,0,0-1.414,0L17.252,5.334A7.285,7.285,0,0,0,13,3.072V1a1,1,0,0,0-2,0V3.072a7.957,7.957,0,0,0-6.5,8.065V16A1.5,1.5,0,0,1,3,17.5a1,1,0,0,0,0,2h.086L.293,22.293a1.015,1.015,0,0,0,0,1.414A1,1,0,0,0,1,23.993Z']],
  AlarmBellRing1: ['alarm-bell-ring-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M4.5,7.5a1.015,1.015,0,0,0,.873-.505A5.372,5.372,0,0,1,7.457,4.9a1,1,0,1,0-.975-1.746A7.335,7.335,0,0,0,3.628,6.013a1,1,0,0,0,.384,1.361A.968.968,0,0,0,4.5,7.5Z', 'M6.432.711A1,1,0,0,0,5.186.044,7.492,7.492,0,0,0,.043,5.187,1,1,0,0,0,.711,6.434,1.038,1.038,0,0,0,1,6.477a1,1,0,0,0,.957-.712A5.5,5.5,0,0,1,5.764,1.958,1,1,0,0,0,6.432.711Z', 'M19.146,4.386a7.391,7.391,0,0,0-1.628-1.228A1,1,0,1,0,16.543,4.9a5.372,5.372,0,0,1,2.085,2.087,1.015,1.015,0,0,0,1.36.383,1,1,0,0,0,.384-1.361A7.438,7.438,0,0,0,19.146,4.386Z', 'M23.957,5.187A7.492,7.492,0,0,0,18.814.044a1,1,0,1,0-.578,1.914,5.5,5.5,0,0,1,3.807,3.807,1.018,1.018,0,0,0,1.246.669A1,1,0,0,0,23.957,5.187Z', 'M13.5,21.5h-3a.5.5,0,0,0-.5.5,2,2,0,1,0,4,0A.5.5,0,0,0,13.5,21.5Z', 'M18.5,13.647V13c0-3.493-2.079-6.479-5-7.27V4.5a1.5,1.5,0,0,0-3,0v1.23c-2.921.791-5,3.777-5,7.27v.646a13.771,13.771,0,0,1-1.447,6.13A.5.5,0,0,0,4.5,20.5h15a.5.5,0,0,0,.447-.724A13.771,13.771,0,0,1,18.5,13.647Z']],
  AlarmBellOff: ['alarm-bell-off', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M14.241,21H9.768a.25.25,0,0,0-.248.222A2.547,2.547,0,0,0,9.5,21.5a2.5,2.5,0,0,0,5,0,2.548,2.548,0,0,0-.015-.278A.249.249,0,0,0,14.241,21Z', 'M9.126,18.5H21a.5.5,0,0,0,.447-.725A16.366,16.366,0,0,1,19.7,10.444V9.676a8.064,8.064,0,0,0-.149-1.605Z', 'M1,23.993a.981.981,0,0,0,.707-.285l22-22a1.022,1.022,0,0,0,0-1.414,1,1,0,0,0-1.415,0L17.68,4.911a16.182,16.182,0,0,0-1.841-1.357A6.377,6.377,0,0,0,13.5,2.636V1.5a1.5,1.5,0,1,0-3,0V2.649a6.752,6.752,0,0,0-2.85,1.277C5.782,5.392,4.3,6.551,4.3,9.676v2.268c0,2.38-.528,3.424-1.581,5.506l-.165.326A.5.5,0,0,0,3,18.5H4.09L.3,22.294A.994.994,0,0,0,1,23.993Z']],
  AlarmBellDisable1: ['alarm-bell-disable-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.5,21.5h-3A.5.5,0,0,0,6,22a2,2,0,0,0,4,0A.5.5,0,0,0,9.5,21.5Z', 'M11.838,7.646A5.662,5.662,0,0,0,9,6.127V4.5a1,1,0,1,0-2,0V6.127C4.168,6.684,2,9.55,2,13v4.5a1,1,0,0,1-1,1,1,1,0,0,0,0,2H15a1,1,0,1,0,0-2,1,1,0,0,1-1-1V13a7.912,7.912,0,0,0-.4-2.508A7.015,7.015,0,0,1,11.838,7.646Z', 'M18.5,0A5.5,5.5,0,1,0,24,5.5,5.5,5.5,0,0,0,18.5,0Zm2.25,8.5a.744.744,0,0,1-.53-.217L18.678,6.738a.252.252,0,0,0-.354,0L16.781,8.281a.75.75,0,1,1-1.06-1.06l1.543-1.543a.252.252,0,0,0,0-.354L15.721,3.781a.75.75,0,1,1,1.06-1.06l1.543,1.543a.252.252,0,0,0,.354,0l1.543-1.543a.75.75,0,0,1,1.06,1.06L19.738,5.324a.252.252,0,0,0,0,.354l1.543,1.543a.747.747,0,0,1-.53,1.277Z']],
  AlarmBellSleep1: ['alarm-bell-sleep-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23,15H21.546l2.245-2.886A1,1,0,0,0,23,10.5H19.5a1,1,0,0,0,0,2h1.456l-2.245,2.886A1,1,0,0,0,19.5,17H23a1,1,0,0,0,0-2Z', 'M15.5,2h2.39L14.727,5.868A1,1,0,0,0,15.5,7.5H20a1,1,0,0,0,0-2h-2.39l3.164-3.867A1,1,0,0,0,20,0H15.5a1,1,0,0,0,0,2Z', 'M9.5,21.5h-3A.5.5,0,0,0,6,22a2,2,0,0,0,4,0A.5.5,0,0,0,9.5,21.5Z', 'M15,18.5a1,1,0,0,1-1-1V13c0-3.451-2.167-6.317-5-6.874V4.5a1,1,0,1,0-2,0V6.127C4.168,6.684,2,9.55,2,13v4.5a1,1,0,0,1-1,1,1,1,0,0,0,0,2H15a1,1,0,1,0,0-2Z']],
  AlarmBellTimer1: ['alarm-bell-timer-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.5,21.5h-3A.5.5,0,0,0,6,22a2,2,0,0,0,4,0A.5.5,0,0,0,9.5,21.5Z', 'M11.419,7.275A5.566,5.566,0,0,0,9,6.127V4.5a1,1,0,1,0-2,0V6.127C4.168,6.684,2,9.55,2,13v4.5a1,1,0,0,1-1,1,1,1,0,0,0,0,2H15a1,1,0,1,0,0-2,1,1,0,0,1-1-1V13a8.019,8.019,0,0,0-.218-1.866A7.006,7.006,0,0,1,11.419,7.275Z', 'M18.251,0A5.75,5.75,0,1,0,24,5.751,5.756,5.756,0,0,0,18.251,0Zm0,9.5A3.75,3.75,0,1,1,22,5.751,3.755,3.755,0,0,1,18.251,9.5Z', 'M19.751,5H19V3.751a.75.75,0,0,0-1.5,0v2a.75.75,0,0,0,.75.75h1.5a.75.75,0,0,0,0-1.5Z']],
  AlarmBellSleep: ['alarm-bell-sleep', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23,15H21.545l2.245-2.886A1,1,0,0,0,23,10.5H19.5a1,1,0,0,0,0,2h1.456l-2.245,2.886A1,1,0,0,0,19.5,17H23a1,1,0,0,0,0-2Z', 'M15.5,2h2.39L14.726,5.868A1,1,0,0,0,15.5,7.5H20a1,1,0,0,0,0-2H17.61l3.164-3.867A1,1,0,0,0,20,0H15.5a1,1,0,0,0,0,2Z', 'M9.5,21.5h-3A.5.5,0,0,0,6,22a2,2,0,0,0,4,0A.5.5,0,0,0,9.5,21.5Z', 'M14.5,13.647V13c0-3.493-2.079-6.479-5-7.27V4.5a1.5,1.5,0,1,0-3,0v1.23c-2.921.791-5,3.777-5,7.27v.646a13.771,13.771,0,0,1-1.447,6.13A.5.5,0,0,0,.5,20.5h15a.5.5,0,0,0,.447-.724A13.785,13.785,0,0,1,14.5,13.647Z']],
  AlarmClock1: ['alarm-clock-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.5,12.254a9.5,9.5,0,1,0-15.375,7.46L3.793,22.047a1,1,0,0,0,0,1.414,1.014,1.014,0,0,0,1.414,0L7.863,20.8a9.483,9.483,0,0,0,8.274,0l2.656,2.657a1.014,1.014,0,0,0,1.414,0,1,1,0,0,0,0-1.414l-2.332-2.333A9.488,9.488,0,0,0,21.5,12.254Zm-10.25-6.5a.75.75,0,1,1,1.5,0V11.5H15.5a.75.75,0,0,1,0,1.5H12a.75.75,0,0,1-.75-.75Z', 'M7.4,2.27a.5.5,0,0,0,.129-.823,4.486,4.486,0,0,0-6.339,6.34.5.5,0,0,0,.368.161.505.505,0,0,0,.454-.29A11.019,11.019,0,0,1,7.4,2.27Z', 'M19.5.254a4.484,4.484,0,0,0-3.033,1.193.5.5,0,0,0,.129.823,11.019,11.019,0,0,1,5.388,5.388.519.519,0,0,0,.454.29.5.5,0,0,0,.368-.161A4.486,4.486,0,0,0,19.5.254Z']],
  AlarmClock1Alternate: ['alarm-clock-1-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.5,12.252A9.5,9.5,0,1,0,6.125,19.713L3.793,22.045a1,1,0,0,0,0,1.414,1.015,1.015,0,0,0,1.414,0L7.863,20.8a9.492,9.492,0,0,0,8.274,0l2.656,2.656a1.011,1.011,0,0,0,1.414,0,1,1,0,0,0,0-1.414l-2.332-2.332A9.489,9.489,0,0,0,21.5,12.252Zm-17,0a7.5,7.5,0,1,1,7.5,7.5A7.509,7.509,0,0,1,4.5,12.252Z', 'M7.4,2.269a.5.5,0,0,0,.129-.823,4.486,4.486,0,0,0-6.339,6.34.507.507,0,0,0,.445.155.5.5,0,0,0,.377-.284A11.019,11.019,0,0,1,7.4,2.269Z', 'M19.5.252a4.485,4.485,0,0,0-3.033,1.194.5.5,0,0,0,.129.823,11.019,11.019,0,0,1,5.388,5.388.5.5,0,0,0,.376.284.51.51,0,0,0,.446-.155A4.486,4.486,0,0,0,19.5.252Z', 'M15,11.252H13v-3.5a1,1,0,1,0-2,0v4.5a1,1,0,0,0,1,1h3a1,1,0,0,0,0-2Z']],
  AlarmBellTimer: ['alarm-bell-timer', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.625,21.376h-3a.5.5,0,0,0-.5.5,2,2,0,0,0,4,0A.5.5,0,0,0,9.625,21.376Z', 'M11.135,6.25a5.972,5.972,0,0,0-1.51-.644V4.376a1.5,1.5,0,1,0-3,0v1.23c-2.921.791-5,3.777-5,7.27v.646a13.771,13.771,0,0,1-1.447,6.13.5.5,0,0,0,.447.724h15a.5.5,0,0,0,.447-.724,13.785,13.785,0,0,1-1.447-6.13v-.646a8.661,8.661,0,0,0-.054-.972A7.007,7.007,0,0,1,11.135,6.25Z', 'M18.125.126a5.75,5.75,0,1,0,5.75,5.75A5.757,5.757,0,0,0,18.125.126Zm0,9.5a3.75,3.75,0,1,1,3.75-3.75A3.754,3.754,0,0,1,18.125,9.626Z', 'M19.625,5.126h-.75V3.876a.75.75,0,0,0-1.5,0v2a.75.75,0,0,0,.75.75h1.5a.75.75,0,0,0,0-1.5Z']],
  AlarmBellDisable: ['alarm-bell-disable', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.625,21.376h-3a.5.5,0,0,0-.5.5,2,2,0,0,0,4,0A.5.5,0,0,0,9.625,21.376Z', 'M11.422,6.432a6.053,6.053,0,0,0-1.8-.826V4.376a1.5,1.5,0,1,0-3,0v1.23c-2.921.791-5,3.777-5,7.27v.646a13.771,13.771,0,0,1-1.447,6.13.5.5,0,0,0,.447.724h15a.5.5,0,0,0,.447-.724,13.785,13.785,0,0,1-1.447-6.13v-.646a8.587,8.587,0,0,0-.117-1.418A7.006,7.006,0,0,1,11.422,6.432Z', 'M18.375.126a5.5,5.5,0,1,0,5.5,5.5A5.5,5.5,0,0,0,18.375.126Zm2.25,8.493a.747.747,0,0,1-.53-.213L18.552,6.863a.252.252,0,0,0-.354,0L16.655,8.406a.75.75,0,1,1-1.06-1.06L17.138,5.8a.252.252,0,0,0,0-.354L15.6,3.906a.75.75,0,1,1,1.06-1.06L18.2,4.389a.252.252,0,0,0,.354,0L20.1,2.846a.75.75,0,0,1,1.06,1.06L19.612,5.449a.252.252,0,0,0,0,.354l1.543,1.543a.743.743,0,0,1-.53,1.273Z']]
};
exports["default"] = _default;